module.exports = __webpack_public_path__ + "img/jdb.afa7b0bc.png";